import axios from 'axios';

const saApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

saApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('trainaxis_sa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

saApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect on a failed superadmin login (or when already on the login page) —
      // let SuperLogin render "Invalid credentials" instead of reloading it away.
      const url = error.config?.url || '';
      const isLoginAttempt = url.includes('/super-admin/auth/login');
      const onLoginRoute   = window.location.pathname === '/superadmin';
      if (!isLoginAttempt && !onLoginRoute) {
        localStorage.removeItem('trainaxis_sa_token');
        localStorage.removeItem('trainaxis_sa_user');
        window.location.href = '/superadmin';
      }
    }
    return Promise.reject(error);
  }
);

// ── SuperAdmin club creation ────────────────────────────────────────────────
// Creates a club + its Primary Admin (no sign-in). Returns { success, club }.
export const createClub = (payload) => saApi.post('/api/super-admin/clubs', payload);

// Live slug availability check (public endpoint, reused by signup). Returns { available, normalized }.
export const checkClubSlug = (slug) => saApi.post('/api/clubs/check-slug', { slug });

// ── Club-owner invitations (invite-based club creation) ─────────────────────────
export const createClubInvitation = (payload) => saApi.post('/api/super-admin/club-invitations', payload);
export const listClubInvitations  = () => saApi.get('/api/super-admin/club-invitations');
export const revokeClubInvitation = (id) => saApi.post(`/api/super-admin/club-invitations/${id}/revoke`);
export const resendClubInvitation = (id) => saApi.post(`/api/super-admin/club-invitations/${id}/resend`);

// ── Team management & account security ──────────────────────────────────────────
export const createTeamMember   = (payload) => saApi.post('/api/super-admin/admins', payload);
export const updateTeamRole     = (id, role) => saApi.put(`/api/super-admin/admins/${id}/role`, { role });
export const updateTeamStatus   = (id, isActive) => saApi.put(`/api/super-admin/admins/${id}/status`, { isActive });
export const changeMyPassword   = (payload) => saApi.post('/api/super-admin/account/change-password', payload);

export default saApi;
